import { B, PD } from "../theme";

/* Shared controls for the growth app. Primary buttons are one flat accent
   fill, no gradient or glow (ba-024, the critic run); ghost buttons stay quiet. */

export const SKY = {
  a: "#7E8EC2",      // Star Charts accent
  b: "#68B8C8",      // Western cyan
  glow: "rgba(126,142,194,0.35)",
  fill: "#A9B4E4",   // the one primary-action fill (ink on it is 9:1)
  fillHover: "#BCC5EC",
  ink: "#0C0E1A",
};

export function PrimaryButton({ children, onClick, disabled, type = "button", style, ...rest }) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className="tw-primary"
      style={{
        ...B, fontSize: 15, fontWeight: 600, letterSpacing: "0.02em",
        color: SKY.ink, border: "none", borderRadius: 999,
        padding: "16px 34px", minHeight: 52, cursor: disabled ? "default" : "pointer",
        backgroundColor: disabled ? PD.thread : SKY.fill,
        opacity: disabled ? 0.55 : 1,
        transition: "transform 0.2s ease, background-color 0.2s ease, opacity 0.2s",
        ...style,
      }}
      {...rest}
    >
      {children}
    </button>
  );
}

export function GhostButton({ children, onClick, style, ...rest }) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        ...B, fontSize: 14, fontWeight: 500, color: PD.sub,
        background: "none", border: "none", padding: "12px 16px", minHeight: 44,
        cursor: "pointer", transition: "color 0.2s",
        ...style,
      }}
      {...rest}
    >
      {children}
    </button>
  );
}

/** Global styles the new screens rely on (hover/active states, keyframes). */
export function UiStyles() {
  return (
    <style>{`
      .tw-primary:not(:disabled):hover{background-color:${SKY.fillHover}!important}
      .tw-primary:focus-visible{outline:2px solid ${SKY.fillHover};outline-offset:3px}
      .tw-primary:not(:disabled):active{transform:scale(0.98)}
      .tw-field{transition:border-color .2s, box-shadow .2s}
      .tw-field:focus{border-color:#7E8EC2!important;box-shadow:0 0 0 3px rgba(126,142,194,0.18)}
      .tw-card-tap{transition:border-color .2s, background .2s, transform .15s}
      .tw-card-tap:active{transform:scale(0.99)}
      @keyframes twRise{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:none}}
      @keyframes twFade{from{opacity:0}to{opacity:1}}
      @keyframes twSpin{to{transform:rotate(360deg)}}
      @keyframes twPulse{0%,100%{opacity:.45}50%{opacity:1}}
      input[type=date].tw-field::-webkit-calendar-picker-indicator,input[type=time].tw-field::-webkit-calendar-picker-indicator{filter:invert(0.8);opacity:.7;cursor:pointer}
      @media(prefers-reduced-motion:reduce){.tw-rise{animation:none!important;opacity:1!important}}
    `}</style>
  );
}

export const fieldStyle = {
  ...B, fontSize: 17, color: PD.text, background: PD.bgCard,
  border: `1px solid ${PD.borderLit}`, borderRadius: 14, outline: "none",
  padding: "16px 18px", width: "100%", minHeight: 56,
  colorScheme: "dark",
};
